import { memoize } from 'lodash'
import { format, parseISO } from 'date-fns'

const _getRetailItineraryTitle = (layovers) => {
  if (!layovers) {
    return ''
  }
  switch (layovers.length) {
    case 0:
      return 'Nonstop'
    case 1:
      return '1 Stop'
    case 2:
      return '2 Stops'
    default:
      return `${layovers.length} Stops`
  }
}

export const getRetailItineraryTitle = memoize(_getRetailItineraryTitle)

export const getArrivalDateText = (overnightDays, arrivalDate) => {
  // Move this to FLy ql when AIR_LISTINGS_ARRIVES_NEXT_DAY_TEXT is winner
  return overnightDays && arrivalDate ? format(parseISO(arrivalDate), 'EEE, MMM d') : ''
}

export const getIncludedAncillaries = (ancillaries) => {
  const includedAncillaries = []
  ancillaries?.forEach((anc) => {
    if (anc.tag === 'CARRY_ON' && anc.offerType === 'C') {
      includedAncillaries.push('carry-on')
    }
    if (anc.tag === 'SEATS' && anc.offerType === 'C') {
      includedAncillaries.push('seat selection')
    }
    if (anc.tag === 'CHECKED_BAG' && anc.offerType === 'C') {
      includedAncillaries.push('checked bag')
    }
  })
  return includedAncillaries
}

export const getAncillariesForIconRow = (ancillaries) => {
  return ancillaries
    ?.filter((anc) => anc.offerType === 'C')
    ?.map((anc) => ({
      ...anc,
      name: anc.tag,
      inclusion: 'INCLUDED',
    }))
}
